import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store } from '@utils/configStore'
import { InjectReducer } from '@hoc/index'
import App from './app/App'
// import reportWebVitals from './reportWebVitals'
// import * as serviceWorker from './serviceWorker'
import './i18next/i18n' // multiple languages

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <InjectReducer>
          <App />
        </InjectReducer>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()

// serviceWorker.register()
